import { render, staticRenderFns } from "./UserInfoButton.vue?vue&type=template&id=11c30c6c&scoped=true"
import script from "./UserInfoButton.vue?vue&type=script&lang=js"
export * from "./UserInfoButton.vue?vue&type=script&lang=js"
import style0 from "./UserInfoButton.vue?vue&type=style&index=0&id=11c30c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c30c6c",
  null
  
)

export default component.exports